import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-stockreport',
  templateUrl: './stockreport.component.html',
  styleUrls: ['./stockreport.component.scss']
})
export class StockreportComponent implements OnInit {

  public stores: any[] = [];
  public selectedStore: string = '';
  public StockReport_Row: any[] = [];

  constructor(public appservice: AppService) {}

  ngOnInit(): void {
    this.loadStores();
  }

  // Load store dropdown
  loadStores() {
    this.appservice.get('Api/transaction/get_stores')
      .subscribe({
        next: (res: any) => {
          try {
            const parsed = typeof res === 'string' ? JSON.parse(res) : res;
            const data = Array.isArray(parsed) ? parsed : parsed?.record || [];
            this.stores = data.map((x: any) => ({
              id: x.SM_iid,
              name: x.SM_storeName
            }));
          } catch (err) {
            console.error('Error parsing stores:', err);
            this.stores = [];
          }
        },
        error: (err) => {
          console.error('Error loading stores:', err);
          this.stores = [];
        }
      });
  }

  // Show button click
  display() {
    if (!this.selectedStore) return;

    this.appservice.get(`Api/transaction/get_stockReport?branch=${this.selectedStore}`)
      .subscribe({
        next: (res: any) => {
          console.log('Raw response:', res);

          let parsed: any;
          try {
            parsed = typeof res === 'string' ? JSON.parse(res) : res;
          } catch (err) {
            console.error('Parsing error:', err);
            parsed = [];
          }

          // If response is nested under "record", extract it
          if (!Array.isArray(parsed) && parsed?.record) {
            parsed = parsed.record;
          }

          // Ensure it's an array
          this.StockReport_Row = Array.isArray(parsed) ? parsed : [];

          console.log('Parsed StockReport_Row:', this.StockReport_Row);
          console.log('Length:', this.StockReport_Row.length);

          if (!this.StockReport_Row.length) {
            alert('No Data Found');
          }
        },
        error: (err) => {
          console.error('Error fetching stock report:', err);
          this.StockReport_Row = [];
          alert('No Data Found');
        }
      });
  }

  // Export to Excel
  export_excel() {
    if (!this.StockReport_Row?.length) return;

    this.appservice.Excel_Data.items = this.StockReport_Row;
    this.appservice.Excel_Data.Report_Name = 'StockReport';
    this.appservice.Excel_Data.FileName = 'StockReport';
    this.appservice.export_excel();
  }
}
